// Pure function to format error messages for snackbar
export function formatErrorMessage(error: any): string {
  let msg = '';
  if (error?.errors) {
    if (Array.isArray(error.errors)) {
      msg += `\n${error.errors.join('\n')}`;
    } else if (typeof error.errors === 'object') {
      const validationMsgs = Object.entries(error.errors)
        .map(([field, messages]) => `${field}: ${(messages as string[]).join(', ')}`)
        .join('\n');
      msg += `\n${validationMsgs}`;
    }
  }
  if (!msg.trim()) {
    return 'Invalid request. Please check your input.';
  }
  return msg;
}
